declare namespace $ {

	type $mol_string__value_shm_surreal_profile_form_1 = $mol_type_enforce<
		ReturnType< $shm_surreal_profile_form['endpoint'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__hint_shm_surreal_profile_form_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_labeler__title_shm_surreal_profile_form_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_surreal_profile_form_4 = $mol_type_enforce<
		ReturnType< $shm_surreal_profile_form['Endpoint'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_string__value_shm_surreal_profile_form_5 = $mol_type_enforce<
		ReturnType< $shm_surreal_profile_form['namespace'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_labeler__title_shm_surreal_profile_form_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_surreal_profile_form_7 = $mol_type_enforce<
		ReturnType< $shm_surreal_profile_form['Namespace'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_string__value_shm_surreal_profile_form_8 = $mol_type_enforce<
		ReturnType< $shm_surreal_profile_form['database'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_labeler__title_shm_surreal_profile_form_9 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_surreal_profile_form_10 = $mol_type_enforce<
		ReturnType< $shm_surreal_profile_form['Database'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_string__value_shm_surreal_profile_form_11 = $mol_type_enforce<
		ReturnType< $shm_surreal_profile_form['username'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_labeler__title_shm_surreal_profile_form_12 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_surreal_profile_form_13 = $mol_type_enforce<
		ReturnType< $shm_surreal_profile_form['Username'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_string__type_shm_surreal_profile_form_14 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['type'] >
	>
	type $mol_string__value_shm_surreal_profile_form_15 = $mol_type_enforce<
		ReturnType< $shm_surreal_profile_form['password'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_labeler__title_shm_surreal_profile_form_16 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_surreal_profile_form_17 = $mol_type_enforce<
		ReturnType< $shm_surreal_profile_form['Password'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_button_major__title_shm_surreal_profile_form_18 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_shm_surreal_profile_form_19 = $mol_type_enforce<
		ReturnType< $shm_surreal_profile_form['save'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_view__sub_shm_surreal_profile_form_20 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_surreal_profile_form extends $mol_list {
		Endpoint( ): $mol_string
		Endpoint_label( ): $mol_labeler
		Namespace( ): $mol_string
		Namespace_label( ): $mol_labeler
		Database( ): $mol_string
		Database_label( ): $mol_labeler
		Username( ): $mol_string
		Username_label( ): $mol_labeler
		Password( ): $mol_string
		Password_label( ): $mol_labeler
		save( next?: any ): any
		Save( ): $mol_button_major
		Status( ): $mol_view
		profile_id( ): string
		draft( next?: any ): any
		status( next?: string ): string
		endpoint( next?: string ): string
		namespace( next?: string ): string
		database( next?: string ): string
		username( next?: string ): string
		password( next?: string ): string
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=form.view.tree.d.ts.map